(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const modals = document.querySelectorAll('.product__media-modal');

    modals.forEach(modal => {
      const wrapper = modal.querySelector('.product__media-modal-image-zoom-wrapper');
      const img = modal.querySelector('.product__media-modal-image');
      const thumbs = modal.querySelectorAll('.product__media-modal-thumb');

      if (!wrapper || !img) return;

      // State
      let scale = 1;
      let startScale = 1;
      let translateX = 0;
      let translateY = 0;
      let startX = 0;
      let startY = 0;
      let startDistance = 0;
      let isPinching = false;

      const minScale = 1;
      const maxScale = 3;

      // Reset zoom & pan
      function reset() {
        scale = 1;
        translateX = 0;
        translateY = 0;
        applyTransform();
      }

      function applyTransform() {
        requestAnimationFrame(() => {
          img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
        });
      }

      // Add listener for carousel / modal image changes
      const observer = new MutationObserver(() => {
        reset();
      });
      observer.observe(img, { attributes: true, attributeFilter: ['src'] });

      // Handle thumbnail clicks
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const index = thumb.dataset.index;
          const allImgs = Array.from(modal.querySelectorAll('.product__media-item-mobile img'));
          const newImg = allImgs[index];
          if (newImg) {
            img.src = newImg.src;
            img.alt = newImg.alt || '';
            // Reset immediately (don't wait for load to avoid stale zoom)
            reset();
            // Optional: reset active state
            thumbs.forEach(t => t.classList.remove('is-active'));
            thumb.classList.add('is-active');
          }
        });
      });

      // Touch start
      wrapper.addEventListener('touchstart', e => {
        if (e.touches.length === 1) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        } else if (e.touches.length === 2) {
          isPinching = true;
          startScale = scale;
          const dx = e.touches[0].clientX - e.touches[1].clientX;
          const dy = e.touches[0].clientY - e.touches[1].clientY;
          startDistance = Math.hypot(dx, dy);
        }
      }, { passive: false });

      // Touch move
      wrapper.addEventListener('touchmove', e => {
        if (e.touches.length === 1 && !isPinching) {
          if (scale > minScale) {
            const dx = e.touches[0].clientX - startX;
            const dy = e.touches[0].clientY - startY;
            translateX += dx;
            translateY += dy;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            applyTransform();
            e.preventDefault();
          }
        } else if (e.touches.length === 2 && isPinching) {
          const dx = e.touches[0].clientX - e.touches[1].clientX;
          const dy = e.touches[0].clientY - e.touches[1].clientY;
          const currentDistance = Math.hypot(dx, dy);

          if (startDistance > 0) {
            const pinchScale = currentDistance / startDistance;
            let newScale = startScale * pinchScale;
            newScale = Math.min(Math.max(newScale, minScale), maxScale);
            scale += (newScale - scale) * 0.25; // smooth easing

            applyTransform();
            e.preventDefault();
          }
        }
        e.stopPropagation();
      }, { passive: false });

      // Touch end/cancel
      const cleanup = () => {
        isPinching = false;
        startDistance = 0;
      };
      wrapper.addEventListener('touchend', cleanup);
      wrapper.addEventListener('touchcancel', cleanup);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
